import { render, staticRenderFns } from "./GroupsTemplate.vue?vue&type=template&id=7eb6c02f&scoped=true&"
import script from "./GroupsTemplate.vue?vue&type=script&lang=js&"
export * from "./GroupsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./GroupsTemplate.vue?vue&type=style&index=0&id=7eb6c02f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb6c02f",
  null
  
)

export default component.exports